import {Component, effect, inject} from '@angular/core';
import {AppStateService} from "../../../core/state/app-state.service";

@Component({
    selector: 'app-home-button',
    templateUrl: './home-button.component.html',
    standalone: false
})
export class HomeButtonComponent {

  protected appStateService = inject(AppStateService);
  redirectionLink = this.appStateService.redirectionURL;
}
